export default __webpack_public_path__ + "static/832-a827e0a8badd7c5f9af7675810169f2b.gif";